import { Vragenboom } from './vragenboom';
import { VariableContent } from './variable-content';

export class IndienenVragenboomRequest {
  contractnummer: string;
  polisnummer: string;
  claimnummer: string;
  subclaimnummer: string;
  taaknummer: string;
  vragenboom: Vragenboom;
  variabele_content_vragenboom: VariableContent[];
}
